import { createSelector } from "reselect";
import moment from "moment";

const compareCoverageByStartDateDescending = (a, b) => {
  if (a.startDate > b.startDate) {
    return -1;
  } else {
    return 1;
  }
};

export const getLatestMemberCoverageForMember = (member) => {
  const memberCoverages = member.memberCoverages.filter(
    (cov) => !cov.isInactive
  );
  let coverage = memberCoverages.find((cov) => cov.endDate === null);
  if (!!coverage) {
    return coverage;
  }
  if (memberCoverages.length) {
    memberCoverages.sort(compareCoverageByStartDateDescending);
    return memberCoverages[0];
  }
  return {};
};

const selectMembers = (state) => {
  const members = state.data.members || {};
  return members.items || [];
};

export const selectMembersWithActiveCoverage = createSelector(
  [selectMembers],
  (members) =>
    members.filter((member) =>
      member.memberCoverages.some(
        (coverage) =>
          !coverage.isInactive &&
          (!coverage.endDate || moment(coverage.endDate) > moment())
      )
    )
);

export const selectMemberOptions = createSelector(
  [selectMembersWithActiveCoverage],
  (members) =>
    members.map((member) => ({
      value: member.memberId,
      text: `${member.firstName} ${member.lastName} / ${member.memberIdentifier}`,
    }))
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/premiumSimulator/premiumSimulatorHelpers.js